import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getPageDetailsByPageTypeId } from "./Services";




export const useGetPageDetailsByPageType= (pageTypeId:number) => {
  return useQuery(
    [endpoints.getPageByPageTypeId,pageTypeId],
    () => getPageDetailsByPageTypeId(pageTypeId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};


